import React from "react";
import { Link } from "react-router-dom";
import {
  Anchor,
  Spinner,
  ListItem,
} from "discover.medical.react-component-library";
import { Accordion, List } from "./styled";
import ExcludedContentMessage from "../ExcludedContentMessage";

// A single accordion, displays a list of topics
const BrowseAccordion = ({
  label,
  columns = 1,
  isOpenDefault = false,
  onAccordionClick,
  onTopicClick,
  topics,
  excludedContent,
}) => {
  const [isOpen, setIsOpen] = React.useState(isOpenDefault);

  const handleClick = (label, isOpen) => {
    if (onAccordionClick) {
      onAccordionClick(label, isOpen);
    }
    setIsOpen(!isOpen);
  };

  const handleTopicClick = (label, slug) => {
    if (onTopicClick) {
      onTopicClick(label, slug);
    }
  };

  const excludedContentMessage = excludedContent?.message;
  const excludedLabels = excludedContent?.labels;
  const shouldShowExcludedContentMessage =
    excludedContentMessage && excludedLabels.includes(label);

  return (
    <Accordion
      animation={false}
      toggleText={label}
      key={label}
      isOpen={isOpen}
      onClick={() => handleClick(label, isOpen)}
    >
      {topics ? (
        <List type="ul" noIndicator={true} columns={columns}>
          {topics.map((item) => (
            <ListItem key={item.title}>
              <Anchor
                linkComponent={Link}
                href={item.slug}
                fontSize="sm"
                onClick={() => handleTopicClick(label, item.slug)}
              >
                {item.title}
              </Anchor>
            </ListItem>
          ))}
        </List>
      ) : (
        <Spinner size="md" />
      )}
      {shouldShowExcludedContentMessage && (
        <ExcludedContentMessage message={excludedContentMessage} />
      )}
    </Accordion>
  );
};

export default BrowseAccordion;
